<template>
  <section class="p-index">
    <section v-if="$store.state.isPc">
      <section class="c-p-r carousel-wrap">
        <el-carousel height="806px" arrow="never" :interval="4000">
          <el-carousel-item v-for="item in swiperList" :key="item.title">
            <div class="c-p-a c-p-c c-ta-c" style="width: 46%;">
              <p class="c-fs-32 c-fw-b c-c-white">{{item.title}}</p>
              <p class="c-mt-36 c-fs-14 c-lh-32 c-c-footer-grey">{{item.content}}</p>
            </div>
            <img :src="item.img">
          </el-carousel-item>
        </el-carousel>
      </section>
    </section>
    <section v-if="!$store.state.isPc">
      <section class="carousel-wrap-mobile">
        <swiper class="swiper" :options="swiperOption1" ref="mySwiper1">
          <swiper-slide v-for="item in swiperListM" :key="item.title">
            <div class="c-p-a c-p-c c-ta-c c-c-white swiper-top-text">
              <p class="c-fs-19 c-fw-b">{{item.title}}</p>
              <p class="c-mt-12 c-fs-9 c-lh-16">{{item.content}}</p>
            </div>
            <img class="img-top-mobile" :src="item.img">
          </swiper-slide>
          <div class="swiper-pagination" id="swiper-pagination1" slot="pagination"></div>
        </swiper>
      </section>
    </section>
    <section class="kernel-all">
      <section v-if="$store.state.isPc">
        <section class="c-d-f c-fd-c c-jc-c cm-width kernel-wrap">
          <div class="c-mb-40">
            <div class="c-d-f c-ai-c c-jc-c">
              <img src="../assets/index/icon.png">
              <span class="c-ml c-mr c-fs-24 c-fw-b c-c-text-color-dark">一大内核</span>
              <div class="c-dot"></div>
              <span class="c-ml c-mr c-fs-24 c-fw-b c-c-text-color-dark">八大模块</span>
              <img src="../assets/index/icon.png">
            </div>
            <p class="c-ta-c c-fs-16 c-c-text-grey">ONE KERNEL AND EIGHT MODULES</p>
          </div>
          <div class="c-lh-24 kernel-content">
            <div class="kernel-item" @click="toUrl('/webMonitor')">
              <img class="kernel-img" src="../assets/index/web.png">
              <p class="c-fs-20 c-mt-36 c-ta-c c-c-text-blue">WEB应用性能监测</p>
              <p class="c-fs-14 c-mt-16 c-c-text-grey c-ta-j">7x24 小时多点跨地区监测 WEB 应用站点的状态及性能，提升系统整体用户体验与服务质量</p>
            </div>
            <div class="kernel-item" @click="toUrl('/serviceMonitor')">
              <img class="kernel-img" src="../assets//index/service.png">
              <p class="c-fs-20 c-mt-36 c-ta-c c-c-text-blue">服务器 & 应用性能监控</p>
              <p class="c-fs-14 c-mt-16 c-c-text-grey c-ta-j">兼容国内外知名服务器厂商的硬件状态，支持操作系统、应用、中间件、数据库等性能运行状态</p>
            </div>
            <div class="kernel-item" @click="toUrl('/internetMonitor')">
              <img class="kernel-img" src="../assets/index/internet.png">
              <p class="c-fs-20 c-mt-36 c-ta-c c-c-text-blue">网络性能监控</p>
              <p class="c-fs-14 c-mt-16 c-c-text-grey c-ta-j">支持国内外知名网络/安全厂商的设备，可满足 CPU、内存、磁盘、接口及硬件状态的持续监控</p>
            </div>
            <div class="kernel-item" @click="toUrl('/storageMonitor')">
              <img class="kernel-img" src="../assets/index/storage.png">
              <p class="c-fs-20 c-mt-36 c-ta-c c-c-text-blue">储存性能监控</p>
              <p class="c-fs-14 c-mt-16 c-c-text-grey c-ta-j">通过 SMI-S 标准协议，监控存储的硬件状态、物理磁盘状态、阵列卡状态、硬盘的 I/O 等性能状态</p>
            </div>
            <div class="kernel-item-center">
              <img class="center-img" src="../assets/index/center.png">
            </div>
            <div class="kernel-item" @click="toUrl('/virtualMonitor')">
              <img class="kernel-img" src="../assets/index/virtual.png">
              <p class="c-fs-20 c-mt-36 c-ta-c c-c-text-blue">虚拟化性能监控</p>
              <p class="c-fs-14 c-mt-16 c-c-text-grey c-ta-j">通过 API 方式兼容国内外各大虚拟化厂商的虚拟化平台，可统计虚拟化环境的硬件资产、虚拟化资产，实时监控虚拟化平台的主机、虚拟机、存储、网络性能运行状态</p>
            </div>
            <div class="kernel-item" @click="toUrl('/configMonitor')">
              <img class="kernel-img" src="../assets/index/config.png">
              <p class="c-fs-20 c-mt-36 c-ta-c c-c-text-blue">配置管理</p>
              <p class="c-fs-14 c-mt-16 c-c-text-grey c-ta-j">可为所有的路由器、交换机和其他网络设备提供配置定时备份、设备巡检、批量配置下发等功能，提高运维效率，提高网络可靠性及安全性</p>
            </div>
            <div class="kernel-item special" @click="toUrl('/ipMonitor')">
              <img class="kernel-img" src="../assets/index/ip.png">
              <p class="c-fs-20 c-mt-36 c-ta-c c-c-text-blue">IP地址管理 & 终端用户追踪</p>
              <p class="c-fs-14 c-mt-16 c-c-text-grey c-ta-j">支持 IPv4/IPv6 地址的管理，可快速管理当前地址的分配/使用、在线/离线情况，识别终端接入设备与端口等信息，实现IP使用的深度管理</p>
            </div>
            <div class="kernel-item" @click="toUrl('/cloundMonitor')">
              <img class="kernel-img" src="../assets/index/clound.png">
              <p class="c-fs-20 c-mt-36 c-ta-c c-c-text-blue">混合云性监控</p>
              <p class="c-fs-14 c-mt-16 c-c-text-grey c-ta-j">支持阿里云、腾讯云、AWS、Aruze 等国内外知名公有云的监控，实现云环境资产与自有数据中心资产的统一管理</p>
            </div>
          </div>
        </section>
      </section>
      <section class="cm-width c-visible-mobile" v-if="!$store.state.isPc">
        <section class="c-mt-40 kernel-wrap-mobile">
          <div class="c-mb-24">
            <div class="c-d-f c-ai-c c-jc-c">
              <img class="c-icon-mobile" src="../assets/index/icon.png">
              <span class="c-ml-8 c-mr-8 c-fs-19 c-fw-b c-c-text-color-dark">一大内核</span>
              <div class="c-dot"></div>
              <span class="c-ml-8 c-mr-8 c-fs-19 c-fw-b c-c-text-color-dark">八大模块</span>
              <img class="c-icon-mobile" src="../assets/index/icon.png">
            </div>
            <p class="c-ta-c c-mt-4 c-fs-10 c-c-text-grey">ONE KERNEL AND EIGHT MODULES</p>
          </div>
          <div class="c-ta-j kernel-content-mobile">
            <swiper class="swiper" :options="swiperOption2" ref="mySwiper2">
              <swiper-slide>
                <div class="c-mb-8 kernel-item" id="/webMonitor">
                  <div class="c-bc-white c-d-f c-ai-c c-pe-none">
                    <img src="../assets/index/web.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">WEB应用性能监测</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">7x24 小时多点跨地区监测WEB应用站点的状态及性能，提升系统整体用户体验与服务质量</p>
                    </div>
                  </div>
                </div>
                <div class="c-mb-8 kernel-item" id="/configMonitor">
                  <div class="c-bc-white c-d-f c-ai-c c-pe-none">
                    <img src="../assets/index/config.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">配置管理</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">可为所有的路由器、交换机和其他网络设备提供配置定时备份、设备巡检、批量配置下发等功能，提高运维效率，提高网络可靠性及安全性</p>
                    </div>
                  </div>
                </div>
                <div class="c-mb-8 kernel-item" id="/virtualMonitor">
                  <div class="c-bc-white c-d-f c-ai-c c-pe-none">
                    <img src="../assets/index/virtual.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">虚拟化性能监控</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">通过 API 方式兼容国内外各大虚拟化厂商的虚拟化平台，可统计虚拟化环境的硬件资产、虚拟化资产，实时监控虚拟化平台的主机、虚拟机、存储、网络性能运行状态</p>
                    </div>
                  </div>
                </div>
                <div class="c-mb-44 kernel-item" id="/storageMonitor">
                  <div class="c-bc-white c-d-f c-ai-c c-pe-none">
                    <img src="../assets/index/storage.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">储存性能监控</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">通过 SMI-S 标准协议，监控存储的硬件状态、物理磁盘状态、阵列卡状态、硬盘的 I/O 等性能状态</p>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="c-mb-8 kernel-item" id="/internetMonitor">
                  <div class="c-bc-white c-d-f c-ai-c c-pe-none">
                    <img src="../assets/index/internet.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">网络性能监控</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">支持国内外知名网络/安全厂商的设备，可满足 CPU、内存、磁盘、接口及硬件状态的持续监控</p>
                    </div>
                  </div>
                </div>
                <div class="c-mb-8 kernel-item" id="/serviceMonitor">
                  <div class="c-bc-white c-d-f c-ai-c c-pe-none">
                    <img src="../assets/index/service.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">服务器&应用性能监控</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">兼容国内外知名服务器厂商的硬件状态，支持操作系统、应用、中间件、数据库等性能运行状态</p>
                    </div>
                  </div>
                </div>
                <div class="c-mb-8 kernel-item" id="/ipMonitor">
                  <div class="c-bc-white c-d-f c-ai-c c-pe-none">
                    <img src="../assets/index/ip.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">IP地址管理 & 终端用户追踪</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">支持 IPv4/IPv6 地址的管理，可快速管理当前地址的分配/使用、在线/离线情况，识别终端接入设备与端口等信息，实现 IP 使用的深度管理</p>
                    </div>
                  </div>
                </div>
                <div class="c-mb-44 kernel-item" id="/cloundMonitor">
                  <div class="c-bc-white c-d-f c-ai-c c-pe-none">
                    <img src="../assets/index/clound.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">混合云性监控</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">支持阿里云、腾讯云、AWS、Aruze 等国内外知名公有云的监控，实现云环境资产与自有数据中心资产的统一管理</p>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-pagination" id="swiper-pagination2" slot="pagination"></div>
            </swiper>
          </div>
        </section>
      </section>
    </section>
    <section class="intelligent-all" v-if="$store.state.isPc">
      <section>
        <section class="cm-width intelligent-wrap">
          <div class="c-mb-100">
            <div class="c-d-f c-ai-c c-jc-c c-fs-24">
              <img src="../assets/index/icon.png">
              <span class="c-ml c-mr c-fw-b c-c-white">让运维工作变得更智能</span>
              <img src="../assets/index/icon.png">
            </div>
            <p class="c-ta-c c-fs-16 c-c-white" style="opacity: 0.5">LET WORK BECOME MORE INTELLIGENT</p>
          </div>
          <div class="intelligent-content">
            <div class="c-p-r">
              <div class="intelligent-desc-left">
                <p class="c-fs-20 c-c-white">快速发现IT资产</p>
                <p class="c-fs-14 c-lh-28 c-mt-16 c-c-footer-grey">通过IP的批量扫描，智能匹配 MonitorWay 资产特征库，快速发现资产数据</p>
              </div>
              <img src="../assets/index/intelligent1.png">
            </div>
            <div class="c-p-r">
              <div class="intelligent-desc-right">
                <p class="c-fs-20 c-c-white">智能拓扑</p>
                <p class="c-fs-14 c-lh-28 c-mt-16 c-c-footer-grey">通过 MonitorWay 拓扑发现的算法，智能发现网络的连接关系，并根据拓扑的复杂程度，智能布局绘制拓扑图</p>
              </div>
              <img src="../assets/index/intelligent2.png">
            </div>
            <div class="c-p-r">
              <div class="intelligent-desc-left left-special">
                <p class="c-fs-20 c-c-white">统一预警中心</p>
                <p class="c-fs-14 c-lh-28 c-mt-16 c-c-footer-grey">针对监控的资产产生的预警，统一预警中心进行分级别统一管理展示，可以快速定位预警问题的，针对问题也可以提供历史解决方案</p>
              </div>
              <img src="../assets/index/intelligent3.png">
            </div>
            <div class="c-d-f c-jc-sb">
              <div class="c-p-r">
                <div class="intelligent-desc-small">
                  <p class="c-fs-20 c-c-white">分权分级管理</p>
                  <p class="c-fs-14 c-lh-28 c-mt-16 c-c-footer-grey">可灵活定制用户的机构、部门及用户，通过角色定义用户的功能操作权限和数据权限，实现复杂的多级机构的分权分级的 IT 资产管理</p>
                </div>
                <img src="../assets/index/intelligent4.png">
              </div>
              <div class="c-p-r">
                <div class="intelligent-desc-small">
                  <p class="c-fs-20 c-c-white">高性能</p>
                  <p class="c-fs-14 c-lh-28 c-mt-16 c-c-footer-grey">支持集群及分布式部署架构，可支撑百万级IT资产集中监控</p>
                </div>
                <img src="../assets/index/intelligent5.png">
              </div>
              <div class="c-p-r">
                <div class="intelligent-desc-small">
                  <p class="c-fs-20 c-c-white">智能运维大屏</p>
                  <p class="c-fs-14 c-lh-28 c-mt-16 c-c-footer-grey">模块化组件式设计，可根据优先级灵活调整布局及展示内容，让您实时了解 IT 系统的运行状况</p>
                </div>
                <img src="../assets/index/intelligent6.png">
              </div>
            </div>
          </div>
        </section>
      </section>
    </section>
    <section class="intelligent-all-mobile" v-if="!$store.state.isPc">
      <section class="">
        <section class="c-mt-40 cm-width intelligent-wrap-mobile">
          <div class="c-mb-24 c-c-white">
            <div class="c-d-f c-ai-c c-jc-c">
              <img  class="c-icon-mobile" src="../assets/index/icon.png">
              <span class="c-ml-8 c-mr-8 c-fs-19 c-fw-b">让运维工作变得更智能</span>
              <img class="c-icon-mobile" src="../assets/index/icon.png">
            </div>
            <p class="c-ta-c c-mt-8 c-fs-10" style="opacity: 0.5">LET WORK BECOME MORE INTELLIGENT</p>
          </div>
          <div class="c-c-white intelligent-content-mobile">
            <swiper class="swiper" :options="swiperOption3" ref="mySwiper3">
              <swiper-slide>
                <div class="c-d-f c-jc-sb c-ai-c c-mb-16 c-pl-16 intelligent-item">
                  <div class="text-wrap">
                    <p class="c-fs-15 c-mb-12">快速发现IT资产</p>
                    <p class="c-fs-12 c-lh-16 c-c-footer-grey">通过IP的批量扫描，智能匹配 MonitorWay 资产特征库，快速发现资产数据</p>
                  </div>
                  <img src="../assets/index/intelligent-m1.png">
                </div>
                <div class="c-d-f c-jc-sb c-ai-c c-mb-16 c-pr-16 intelligent-item">
                  <img src="../assets/index/intelligent-m2.png">
                  <div class="text-wrap text-wrap-right">
                    <p class="c-fs-15 c-mb-12 c-ta-r">智能拓扑</p>
                    <p class="c-fs-12 c-lh-16 c-c-footer-grey">通过 MonitorWay 拓扑发现的算法，智能发现网络的连接关系，并根据拓扑的复杂程度，智能布局绘制拓扑图</p>
                  </div>
                </div>
                <div class="c-d-f c-jc-sb c-ai-c c-mb-44 c-pl-16 intelligent-item">
                  <div class="text-wrap">
                    <p class="c-fs-15 c-mb-12">统一预警中心</p>
                    <p class="c-fs-12 c-lh-16 c-c-footer-grey">针对监控的资产产生的预警，统一预警中心进行分级别统一管理展示，可以快速定位预警问题的，针对问题也可以提供历史的解决方案</p>
                  </div>
                  <img src="../assets/index/intelligent-m3.png">
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="c-d-f c-jc-sb c-ai-c c-mb-16 c-pr-16 intelligent-item">
                  <img src="../assets/index/intelligent-m1.png">
                  <div class="text-wrap text-wrap-right">
                    <p class="c-fs-15 c-mb-12 c-ta-r">分权分级管理</p>
                    <p class="c-fs-12 c-lh-16 c-c-footer-grey">可灵活定制用户的机构、部门及用户，通过角色定义用户的功能操作权限和数据权限，实现复杂的多级机构的分权分级的 IT 资产管理</p>
                  </div>
                </div>
                <div class="c-d-f c-jc-sb c-ai-c c-mb-16 c-pl-16 intelligent-item">
                  <div class="text-wrap">
                    <p class="c-fs-15 c-mb-12">高性能</p>
                    <p class="c-fs-12 c-lh-16 c-c-footer-grey">通过 MonitorWay 支持集群及分布式部署架构，可支撑百万级 IT 资产集中监控</p>
                  </div>
                  <img src="../assets/index/intelligent-m2.png">
                </div>
                <div class="c-d-f c-jc-sb c-ai-c c-mb-44 c-pr-16 intelligent-item">
                  <img src="../assets/index/intelligent-m3.png">
                  <div class="text-wrap text-wrap-right">
                    <p class="c-fs-15 c-mb-12 c-ta-r">智能运维大屏</p>
                    <p class="c-fs-12 c-lh-16 c-c-footer-grey">模块化组件式设计，可根据优先级灵活调整布局及展示内容，让您实时了解 IT 系统的运行状况</p>
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-pagination" id="swiper-pagination3" slot="pagination"></div>
            </swiper>
          </div>
        </section>
      </section>
    </section>
    <section class="partners-all">
      <section v-if="$store.state.isPc">
        <section class="c-d-f c-fd-c c-jc-c cm-width partners-wrap">
          <div class="c-mb-80">
            <div class="c-d-f c-ai-c c-jc-c c-fs-24">
              <img src="../assets/index/icon.png">
              <span class="c-ml c-mr c-fw-b c-c-text-color-dark">合作伙伴</span>
              <img src="../assets/index/icon.png">
            </div>
            <p class="c-ta-c c-fs-16 c-c-text-grey">PARTNERS</p>
          </div>
          <div class="partners-content">
            <img src="../assets/index/button-left.png" @click="changePic(1)" class="c-cs-p left">
            <img src="../assets/index/button-left.png" @click="changePic(2)" class="c-cs-p right">
            <el-carousel
              ref="carousel"
              height="325px"
              indicator-position="outside"
              arrow="never"
              :interval="4000"
              :autoplay="isAutoplay"
              @mouseover.native="isAutoplay = false"
              @mouseout.native="isAutoplay = true"
            >
              <el-carousel-item v-for="(item, index) in partnerList" :key="index">
                <div class="c-d-f c-fw-w carousel-pic">
                  <div class="c-cs-p partners-item" v-for="i in item" :key="i.name">
                    <img :src="i.url" class="svg" :class="i.large === 1 ? 'svg-large' : ''">
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </section>
      </section>
      <section class="cm-width" v-if="!$store.state.isPc">
        <section class="partners-wrap-mobile">
          <div class="c-mb-24 c-mt-40">
            <div class="c-d-f c-ai-c c-jc-c">
              <img class="c-icon-mobile" src="../assets/index/icon.png">
              <span class="c-ml-8 c-mr-8 c-fs-19 c-fw-b c-c-text-color-dark">合作伙伴</span>
              <img class="c-icon-mobile" src="../assets/index/icon.png">
            </div>
            <p class="c-ta-c c-mt-8 c-fs-10 c-c-text-grey">PARTNERS</p>
          </div>
          <div class="partners-content-mobile">
            <swiper class="swiper" :options="swiperOption4" ref="mySwiper4">
              <swiper-slide v-for="(item, index) in mobilePartnerList" :key="index">
                <div class="c-d-f c-fw-w c-mb-44">
                  <div class="partners-item" v-for="i in item" :key="i.name">
                    <img :src="i.url" class="svg-m">
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-pagination" id="swiper-pagination4" slot="pagination"></div>
            </swiper>
          </div>
        </section>
      </section>
    </section>
</section>
</template>

<script>
import { swiperList, swiperListM } from '../constants/index.constants'
import { partnerList, mobilePartnerList } from '../constants/partners.constants'

let Vue = {}
export default {
  name: 'index',
  components: {
  },
  data () {
    return {
      isAutoplay: true,
      swiperList: swiperList,
      swiperListM: swiperListM,
      partnerList: partnerList,
      mobilePartnerList: mobilePartnerList,
      swiperOption1: {
        ...this.$store.state.swiperOptions,
        pagination: {
          el: '#swiper-pagination1',
          clickable: true
        }
      },
      swiperOption2: {
        ...this.$store.state.swiperOptions,
        pagination: {
          el: '#swiper-pagination2',
          clickable: true
        },
        on: {
          click: function (e) {
            // const realIndex = this.realIndex
            Vue.toUrl(e.target.id)
          }
        }
      },
      swiperOption3: {
        ...this.$store.state.swiperOptions,
        pagination: {
          el: '#swiper-pagination3',
          clickable: true
        }
      },
      swiperOption4: {
        ...this.$store.state.swiperOptions,
        pagination: {
          el: '#swiper-pagination4',
          clickable: true
        },
        on: {
          click: function (e) {
            Vue.selectPartner(e.target.id)
          }
        }
      }
    }
  },
  methods: {
    // 轮播图上下页控制
    changePic (index) {
      this.isAutoplay = false
      if (index === 1) {
        this.$refs.carousel.prev()
      } else {
        this.$refs.carousel.next()
      }
      setTimeout(() => {
        this.isAutoplay = true
      }, 0)
    },
    toUrl (id) {
      if (id) {
        this.$router.push(id)
      }
    },
    selectPartner (id) {
    }
  },
  mounted () {
    Vue = this
  }
}
</script>

<style lang="scss">
.p-index {
  .carousel-wrap {
    min-width: 1180px;
    height: 806px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .el-carousel {
      .el-carousel__button {
        height: 4px;
        border-radius: 2px;
        background-color: #CDCDCD;
        opacity: 0.64;
      }
      .el-carousel__indicators, .el-carousel__indicators--horizontal {
        .is-active {
          .el-carousel__button {
            width: 82px;
            height: 4px;
            background-color: orange;
            opacity: 1;
          }
        }
      }
    }
  }
  .carousel-wrap-mobile {
    .img-top-mobile {
      width: 100%;
      height: 232px;
      object-fit: cover;
    }
    .swiper-top-text {
      width: calc(100% - 62px);
    }
    .swiper {
      width: 100%;
      --swiper-theme-color: #FF8243; // 不能使用$orange
      .swiper-pagination, .swiper-pagination-bullets {
        bottom: 16px;
        .swiper-pagination-bullet {
          width: 20px;
          height: 3px;
          border-radius: 1.5px;
          margin: 0 4px;
          outline: none;
        }
        .swiper-pagination-bullet-active {
          width: 50px;
        }
      }
    }
  }
  .kernel-all {
    @media screen and (min-width: $min-width-standard) {
      background: url('../assets/index/kernel-bg.png') no-repeat;
      background-position: bottom;
      background-size: 100%;
    }
    .kernel-wrap {
      margin-top: 80px;
      .kernel-content {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-bottom: 100px;
        .kernel-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 378px;
          min-height: 476px;
          margin-top: 24px;
          padding: 80px 56px;
          padding-bottom: 88px;
          border-radius: 1px;
          cursor: pointer;
          background-color: white;
          transition: all 0.3s ease-in-out;
          box-shadow: 0 8px 34px 0 rgba(0, 31, 255, 0.05);
          &::before {
            content: "";
            width: 0;
            height: 4px;
            background: $orange;
            position: absolute;
            top: 0;
            left: 50%;
            transition: all 0.3s;
          }
          &:hover {
            transform: translateY(-16px);
          }
          &:hover::before {
            left: 0;
            width: 100%;
          }
        }
        .kernel-item-center {
          display: flex;
          align-items: center;
          justify-content: center;
          background: transparent;
          padding: 64px 40px;
          padding-top: 70px;
          cursor: default;
          .center-img {
            width: 80%;
          }
        }
        .special {
          padding: 80px 52px;
          padding-bottom: 88px;
        }
      }
    }
    .kernel-content-mobile {
      .swiper {
        width: 100%;
        --swiper-theme-color: #FF8243; // 不能使用$orange
        .swiper-pagination, .swiper-pagination-bullets {
          bottom: 15px;
          .swiper-pagination-bullet {
            width: 20px;
            height: 3px;
            border-radius: 1.5px;
            margin: 0 4px;
            outline: none;
          }
          .swiper-pagination-bullet-active {
            width: 50px;
          }
        }
      }
      .kernel-item {
        padding: 25px 16px;
        background: white;
        img {
          width: 60px;
          height: 60px;
          object-fit: contain;
        }
      }
    }
  }
  .intelligent-all {
    padding-top: 80px;
    padding-bottom: 124px;
    width: 100%;
    background: url('../assets/index/intelligent-bg.png') no-repeat;
    background-size: cover;
    .intelligent-wrap {
      .intelligent-content {
        font-size: 0;
        .intelligent-desc-left {
          width: 38%;
          position: absolute;
          left: 8%;
          top: 44%;
          font-size: 14px;
          letter-spacing: 1px;
          &.left-special {
            top: 38%;
          }
        }
        .intelligent-desc-right {
          width: 38%;
          position: absolute;
          right: 8%;
          top: 42%;
          text-align: right;
          font-size: 14px;
          letter-spacing: 1px;
        }
        .intelligent-desc-small {
          width: 60%;
          position: absolute;
          top: 14%;
          left: 20%;
          text-align: justify;
        }
        img {
          width: 100%;
        }
      }
    }
  }
  .intelligent-all-mobile {
    padding-top: 40px;
    width: 100%;
    background: #052385;
    background-size: cover;
    .intelligent-wrap-mobile {
      .intelligent-content-mobile {
        .intelligent-item {
        height: 137px;
        background-image: linear-gradient(90deg, #1443B7 0%, rgba(5,36,133,0.00) 100%);
        border-radius: 3px;
        .text-wrap {
          width: 60%;
          text-align: justify;
          &.text-wrap-right {
            @media screen and (min-width: 550px){
              text-align: right;
            }
          }
        }
        img {
          width: 110px;
          height :110px;
        }
      }
      & .intelligent-item:nth-of-type(even) {
        background-image: linear-gradient(90deg, rgba(5,36,133,0.13) 0%, #1445C0 100%);
      }
        .swiper {
          width: 100%;
          --swiper-theme-color: #FF8243; // 不能使用$orange
          .swiper-pagination, .swiper-pagination-bullets {
            bottom: 15px;
            .swiper-pagination-bullet {
              width: 20px;
              height: 3px;
              border-radius: 1.5px;
              margin: 0 4px;
              outline: none;
            }
            .swiper-pagination-bullet-active {
              width: 50px;
            }
          }
        }
      }
    }
  }
  .partners-all {
    @media screen and (min-width: $min-width-standard) {
      background: url('../assets/index/partner-bg.png') no-repeat;
      background-position: center;
      background-size: 100% 100%;
      padding-top: 80px;
      padding-bottom: 160px;
    }
    .svg {
      position: absolute;
      left: 50%;
      top: 50%;
      transform:translate(-50%, -50%);
      max-width: 120px;
      max-height: 80px;
      &.svg-large {
        max-height: 60px;
      }
    }
    .svg-m {
      position: absolute;
      left: 50%;
      top: 50%;
      transform:translate(-50%, -50%);
      max-width: 60%;
      max-height: 40px;
    }
    .partners-wrap {
      .partners-content {
        position: relative;
        .el-carousel {
          .el-carousel__button {
            height: 4px;
            border-radius: 2px;
            background-color: #CDCDCD;
            opacity: 0.64;
          }
          .el-carousel__indicators, .el-carousel__indicators--horizontal {
             margin-top: 84px;
            .is-active {
              .el-carousel__button {
                width: 82px;
                height: 4px;
                background-color: orange;
                opacity: 1;
              }
            }
          }
        }
        .carousel-pic {
          .partners-item {
            width: 25%;
            height: 162px;
            display: block;
            box-sizing: border-box;
            position: relative;
            border: 1px solid #D1D8E8;
            border-right: none;
            &::before {
              content: "";
              width: 100%;
              height: 4px;
              background: $orange;
              position: absolute;
              top: 0;
              display: none;
            }
            &:hover::before {
              display: block;
            }
            &:hover {
              background: white;
              box-shadow: 0 10px 25px 0 rgba(0, 31, 255, 0.05);
            }
          }
          & .partners-item:nth-of-type(4) {
            border-right: 1px solid #D1D8E8;
          }
          & .partners-item:nth-last-of-type(1) {
            // width: calc(25% + 1px);
            border-top: none;
            border-right: 1px solid #D1D8E8;
          }
          & .partners-item:nth-of-type(5) {
            border-top: none;
          }
          & .partners-item:nth-of-type(6) {
            border-top: none;
          }
          & .partners-item:nth-of-type(7) {
            border-top: none;
          }
        }
        .left {
          position: absolute;
          left: -148px;
          top: 138px;
          @media screen and (max-width: 1475px) {
            display: none;
          }
        }
        .right {
          position: absolute;
          right: -148px;
          top: 138px;
          transform: rotate(180deg);
          @media screen and (max-width: 1475px) {
            display: none;
          }
        }
      }
    }
    .partners-wrap-mobile {
      .swiper {
        width: 100%;
        --swiper-theme-color: #FF8243; // 不能使用$orange
        .swiper-pagination, .swiper-pagination-bullets {
          bottom: 15px;
          .swiper-pagination-bullet {
            width: 20px;
            height: 3px;
            border-radius: 1.5px;
            margin: 0 4px;
            outline: none;
          }
          .swiper-pagination-bullet-active {
            width: 50px;
          }
        }
      }
      .partners-content-mobile {
        padding-bottom: 25px;
        .partners-item {
          width: calc(100% / 3);
          height: 81px;
          background: #FFFFFF;
          border: 1px solid #D1D8E8;
          border-right: none;
          position: relative;
        }
        & .partners-item:nth-of-type(3) {
          border-right: 1px solid #D1D8E8;
        }
        & .partners-item:nth-of-type(4) {
          border-top: none;
        }
        & .partners-item:nth-of-type(5) {
          border-top: none;
        }
        & .partners-item:nth-last-of-type(1) {
          border-top: none;
          border-right: 1px solid #D1D8E8;
        }
      }
    }
  }
}
</style>
